// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ReminderUserSettingsRecordDataActivitySummary {
  readonly id: string;
  readonly name: string;
  readonly startTime: DateTime;
  readonly activityCategory: Enums.ActivityCategory;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.startTime = DateHelpers.ParseServerDateTime(data.startTime);
    this.activityCategory =
      data.activityCategory === undefined ? Enums.ActivityCategory.Task : data.activityCategory;
  }

  static zero(): ReminderUserSettingsRecordDataActivitySummary {
    const zeroValues: ExcludeMethodsDeep<ReminderUserSettingsRecordDataActivitySummary> = {
      id: NIL_UUID,
      name: '',
      startTime: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      activityCategory: Enums.ActivityCategory.Task,
    };
    return new ReminderUserSettingsRecordDataActivitySummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReminderUserSettingsRecordDataActivitySummaryWireFormat = {
  id: string;
  name: string;
  startTime: string;
  activityCategory: string;
};

type NewReminderUserSettingsRecordDataActivitySummaryProps = PartialDeep<
  ReminderUserSettingsRecordDataActivitySummary,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordDataActivitySummary: (
  props: NewReminderUserSettingsRecordDataActivitySummaryProps,
) => ReminderUserSettingsRecordDataActivitySummary = (props) =>
  new ReminderUserSettingsRecordDataActivitySummary(props);

type NewReminderUserSettingsRecordDataActivitySummaryFromWireFormatProps = PartialDeep<
  ReminderUserSettingsRecordDataActivitySummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordDataActivitySummaryFromWireFormat: (
  props: NewReminderUserSettingsRecordDataActivitySummaryFromWireFormatProps,
) => ReminderUserSettingsRecordDataActivitySummary = (props) =>
  new ReminderUserSettingsRecordDataActivitySummary(props);
